import axios from 'axios';
import store from "../store/index.js"

const http = axios.create({
  baseURL: "https://manage-my-comics.herokuapp.com",
  headers: {
      "Authorization": `Bearer ${store.state.token}`
  }    
});

export default {

  login(user) {
    return http.post('/login', user)
  },

  register(user) {
    return http.post('/register', user)
  }

}
